define(['jquery'], function ($) {
  'use strict';

  return function copyrightDateChanger() {
    const d = new Date();
    let year = d.getFullYear();
    $("#copyright-year").html(year);
  }
});
